import type { AppRouteRecordRaw } from "../types/types";

import { RouteNames } from "@/app/router/types/names";
import { guestGuard } from "@/app/router/utils/guards";

const authRoutes: AppRouteRecordRaw[] = [
  {
    path: "/login",
    name: RouteNames.LOGIN,
    component: () => import("@/pages/Auth/LoginPage.vue"),
    meta: {
      title: "Login",
      layout: "auth",
      requiresAuth: false,
      menuIcon: "mdi:login",
      showInMenu: false,
    },
    beforeEnter: guestGuard,
  },
  {
    path: "/password-forgot",
    name: RouteNames.FORGET_PASSWORD,
    meta: {
      layout: "auth",
      requiresAuth: false,
      showInMenu: false,
    },
    component: () => import("@/pages/Auth/ForgotPasswordPage.vue"),
    beforeEnter: guestGuard,
  },
  {
    path: "/reset-password",
    name: RouteNames.REST_PASSWORD,
    meta: {
      layout: "auth",
      showInMenu: false,
      requiresAuth: false,
    },
    component: () => import("@/pages/Auth/ResetPasswordPage.vue"),
  },
  {
    path: "/password-change",
    name: RouteNames.PASSWORD_CHANGE,
    meta: {
      showInMenu: false,
      requiresAuth: true,
      partnerships: ["seller", "vendor"],
      filters: {
        show: [],
      },
    },
    component: () => import("@/pages/Auth/PasswordChange.vue"),
  },
  {
    path: "/oauth/consent",
    name: RouteNames.MCP_CONSENT,
    component: () => import("@/pages/Auth/McpConsentPage.vue"),
    meta: {
      title: "Authorize application",
      layout: "auth",
      requiresAuth: true,
      showInMenu: false,
      // Without this the route is seller-only by convention and vendor users
      // get bounced before they can grant anything.
      partnerships: ["seller", "vendor"],
    },
  },
];

export default authRoutes;
